// Constantes du jeu Réminiscence (Frontend)

// Règles du jeu (CRITIQUES - synchronisées avec le backend)
export const GAME_CONSTANTS = {
  // Jetons Sablier
  INITIAL_TOKENS_PER_PLAYER: 7,
  ACTION_COST: 1,
  MIME_REWARD: 1,

  // Plateau
  BOARD_SIZE: 7,
  TOTAL_SYMBOLS: 24,

  // Cartes
  CARDS_PER_HAND: 3,
  BIG_BANG_CARDS: 5,
  BIG_BANG_DURATION: 30000, // 30 secondes

  // Joueurs
  MIN_PLAYERS: 2,
  MAX_PLAYERS: 4,

  // Validation narrative (RÈGLE CRITIQUE)
  NARRATIVE_MIN_LENGTH: 15,
  NARRATIVE_MAX_LENGTH: 200,
} as const;

// Mapping des 24 symboles Lucide React (RÉFÉRENCE - NE PAS CHANGER LES IDs)
export const SYMBOLS_MAPPING = {
  1: 'Key',
  2: 'Clock', // Watch → Clock pour Lucide
  3: 'Compass',
  4: 'BookOpen',
  5: 'Feather',
  6: 'Flame',
  7: 'Globe',
  8: 'Wind',
  9: 'Eye',
  10: 'Scroll',
  11: 'Ghost',
  12: 'Crown',
  13: 'Sword',
  14: 'Ship',
  15: 'Wine', // Sera remplacé par GlassWater
  16: 'Stamp',
  17: 'Map',
  18: 'Sun',
  19: 'Drama', // Sera remplacé par Theater
  20: 'Coins',
  21: 'Anchor',
  22: 'Camera',
  23: 'Star',
  24: 'Footprints'
} as const;

// Couleurs des joueurs
export const PLAYER_COLORS = [
  { name: 'Rouge Corail', value: '#FF6B6B', class: 'bg-red-400' },
  { name: 'Turquoise', value: '#4ECDC4', class: 'bg-teal-400' },
  { name: 'Bleu Ciel', value: '#45B7D1', class: 'bg-blue-400' },
  { name: 'Vert Menthe', value: '#96CEB4', class: 'bg-green-400' },
  { name: 'Jaune Doux', value: '#FFEAA7', class: 'bg-yellow-300' },
  { name: 'Violet Clair', value: '#DDA0DD', class: 'bg-purple-300' }
] as const;

// Messages d'interface
export const UI_MESSAGES = {
  // Lobby
  WELCOME: 'Bienvenue dans Réminiscence',
  CREATE_ROOM: 'Créer une nouvelle partie',
  JOIN_ROOM: 'Rejoindre une partie',
  WAITING_PLAYERS: 'En attente d\'autres joueurs...',

  // Fil Rouge
  CHOOSE_THEME: 'Choisissez votre Fil Rouge',
  THEME_PLACEHOLDER: 'Ex: "Mon Expédition Perdue", "La Cuisine de Mamie"...',
  THEME_HELP: 'Toutes vos actions devront être justifiées par ce thème',

  // Narration
  NARRATIVE_REQUIRED: 'Racontez votre histoire',
  NARRATIVE_PLACEHOLDER: 'Comment cette action s\'intègre-t-elle à votre thème ?',
  NARRATIVE_TOO_SHORT: `Votre histoire doit contenir au moins ${GAME_CONSTANTS.NARRATIVE_MIN_LENGTH} caractères`,
  NARRATIVE_TOO_LONG: `Votre histoire ne peut pas dépasser ${GAME_CONSTANTS.NARRATIVE_MAX_LENGTH} caractères`,

  // Actions
  ACTION_INVEST: 'Investir (Poser une carte)',
  ACTION_CONQUER: 'Conquérir (Deviner une carte)',
  ACTION_SPY: 'Mode Espionnage activé',
  ACTION_HELP: 'Demander de l\'aide',

  // États spéciaux
  BIG_BANG: 'Big Bang ! Mémorisez ces cartes',
  LAST_BREATH: 'Dernier Souffle ! Une chance de survie',
  SPECTATOR: 'Vous êtes maintenant spectateur',

  // Succès/Erreurs
  SUCCESS_GENERAL: 'Action réussie !',
  ERROR_GENERAL: 'Une erreur s\'est produite',
  CONNECTION_LOST: 'Connexion perdue avec le serveur',
  RECONNECTING: 'Reconnexion en cours...',
} as const;

// Configuration Socket.io
export const SOCKET_CONFIG = {
  SERVER_URL: (import.meta as any).env?.VITE_SERVER_URL || 'http://localhost:5001',
  RECONNECTION_ATTEMPTS: 5,
  RECONNECTION_DELAY: 1000,
  TIMEOUT: 20000,
} as const;

// Durées d'animation (en millisecondes)
export const ANIMATION_DURATIONS = {
  FAST: 200,
  NORMAL: 300,
  SLOW: 500,
  CARD_FLIP: 600,
  PARTICLE_EFFECT: 2000,
  NOTIFICATION: 4000,
} as const;

// Breakpoints responsive
export const BREAKPOINTS = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  '2XL': 1536,
} as const;

// Thèmes prédéfinis pour inspiration
export const THEME_SUGGESTIONS = [
  'Mon Expédition Perdue',
  'La Cuisine de Mamie',
  'Mes Vacances sur Mars',
  'L\'École de Magie',
  'Le Laboratoire Secret',
  'La Bibliothèque Enchantée',
  'Mon Voyage dans le Temps',
  'L\'Atelier de l\'Inventeur',
  'La Forêt Mystérieuse',
  'Le Château Hanté',
  'Mon Cirque Extraordinaire',
  'L\'Île aux Trésors'
] as const;

// Configuration des notifications
export const NOTIFICATION_CONFIG = {
  DEFAULT_DURATION: 4000,
  SUCCESS_DURATION: 3000,
  ERROR_DURATION: 6000,
  WARNING_DURATION: 5000,
  MAX_NOTIFICATIONS: 5,
} as const;
